import React from 'react';
import { Button } from 'rsuite';
import { ContentContainer, LoadingMenu } from '../../../../../components';
import SelectPill from '../../../../../components/SelectPill';
import styles from './FiltersArea.module.scss';
import { useGetPrecificacaoFilterList } from '../../hooks/useGetPrecificacaoFilterList';
import { FilterNames, SelectObjType } from '../../types';

type FiltersAreaProps = {
  onClose: (name: FilterNames) => void;
  onSelect: (name: FilterNames, value: string[]) => void;
  onClean: (name: FilterNames) => void;
  onClickCleanFilters: () => void;
};

const locale = {
  noResultsText: 'Nenhum item encontrado',
  searchPlaceholder: 'Buscar item',
};

export const FiltersArea = ({ onClose, onSelect, onClean, onClickCleanFilters }: FiltersAreaProps) => {
  const { familiaList, tierList, descricaoList, handleSearchPrecificacaoFilters, handleSelectFilterItem, handleCleanFilter } = useGetPrecificacaoFilterList();

  const handleSelect = (name: FilterNames, value: string[], item: SelectObjType) => {
    handleSelectFilterItem(name, item);
    onSelect(name, value);
  };

  const handleClean = (name: FilterNames) => {
    handleCleanFilter(name);
    onClean(name);
  };

  const handleCleanAllFilters = () => {
    handleClean('familias');
    handleClean('tiers');
    handleClean('descricoes');
    onClickCleanFilters();
  };

  return (
    <ContentContainer className={styles['filters-area-container']}>
      <div className={styles['inside-container']}>
        <div className={styles['filters-wrapper']}>
          <SelectPill
            type="check"
            id="check-picker-pill"
            placeholder="Produto"
            value={descricaoList.value}
            data={descricaoList.list}
            onSearch={(value: string) => handleSearchPrecificacaoFilters('descricoes', value)}
            onOpen={() => handleSearchPrecificacaoFilters('descricoes', '')}
            onClose={() => onClose('descricoes')}
            onSelect={(value, item) => handleSelect('descricoes', value, item)}
            onClean={() => handleClean('descricoes')}
            locale={locale}
            renderMenu={menu => (
              <span>
                <LoadingMenu area="precificacao-filters" />
                {menu}
              </span>
            )}
          />
          <SelectPill
            type="check"
            id="check-picker-pill"
            placeholder="Família"
            value={familiaList.value}
            data={familiaList.list}
            onSearch={(value: string) => handleSearchPrecificacaoFilters('familias', value)}
            onOpen={() => handleSearchPrecificacaoFilters('familias', '')}
            onClose={() => onClose('familias')}
            onSelect={(value, item) => handleSelect('familias', value, item)}
            onClean={() => handleClean('familias')}
            locale={locale}
            renderMenu={menu => (
              <span>
                <LoadingMenu area="precificacao-filters" />
                {menu}
              </span>
            )}
          />
          <SelectPill
            type="check"
            id="check-picker-pill"
            placeholder="Tier de produto"
            value={tierList.value}
            data={tierList.list}
            onSearch={(value: string) => handleSearchPrecificacaoFilters('tiers', value)}
            onOpen={() => handleSearchPrecificacaoFilters('tiers', '')}
            onClose={() => onClose('tiers')}
            onSelect={(value, item) => handleSelect('tiers', value, item)}
            onClean={() => handleClean('tiers')}
            locale={locale}
            renderMenu={menu => (
              <span>
                <LoadingMenu area="precificacao-filters" />
                {menu}
              </span>
            )}
          />
        </div>
        <Button className={styles['btn-clear-filters']} onClick={handleCleanAllFilters}>
          Limpar filtros
        </Button>
      </div>
    </ContentContainer>
  );
};
